import * as _ from "lodash";
import { loadFolderJSONs } from "../utils/files";
import Passage from "../domain/Passage";
import moment from "moment";
import Message from "../domain/Message";
import produce from "immer";
import { getPersistor } from "@rematch/persist";

// noinspection JSUnresolvedFunction
export const storyFiles = loadFolderJSONs(require.context("stories", false, /\.json$/));
export const storyNames = _.keys(storyFiles);

export const storyModels = _.mapValues(storyFiles, story => {
  const allPassages = _.map(story.passages, it => new Passage(it));

  const firstPassage = _.find(allPassages, { tags: ["start"] });
  const storyName = story.fileName;
  const INITIAL_STATE = {
    currentPassage: null,
    receivedMessages: [],
    imageGallery: _.chain(allPassages)
      .flatMap(it => it.getReceivableMessages())
      .filter(msg => msg.isImage())
      .map(it => {
        it.isUnlocked = false;
        return it
      })
      .value(),
    scheduledMessages: [],
    hasReachedEnding: false
  };

  return {
    state: INITIAL_STATE,

    reducers: {
      clearStoryData: state => {
        state.scheduledMessages.map(it => {
          clearTimeout(it.timerId)
        });
        return {
          ...state,
          receivedMessages: INITIAL_STATE.receivedMessages,
          scheduledMessages: INITIAL_STATE.scheduledMessages,
          currentPassage: INITIAL_STATE.currentPassage
        };
      },

      clearAllStoryData: state => {
        state.scheduledMessages.map(it => {
          clearTimeout(it.timerId)
        });
        return INITIAL_STATE;
      },

      receiveMessage: (state, message) => produce(state, draft => {
        if (message.isImage()) {
          const image = _.find(draft.imageGallery, it => new Message(it).getSourceFromImage() === message.getSourceFromImage());
          image.isUnlocked = true;
        }
        draft.receivedMessages.push(message);
      }),

      scheduleMessage: (state, message) => produce(state, draft => {
        draft.scheduledMessages.push({ message })
      }),

      updateScheduledMessage: (state, message, timerId) => produce(state, draft => {
        draft.scheduledMessages.map(it => {
          it.message = new Message(it.message);
          return it
        });
        const scheduledMessage = _.find(draft.scheduledMessages, { message: { id: message.id } });
        scheduledMessage.timerId = timerId;
      }),

      clearScheduledMessage: (state, message) => produce(state, draft => {
        draft.scheduledMessages.map(it => it.message = new Message(it.message));
        _.remove(draft.scheduledMessages, { message: { id: new Message(message).id } });
      }),

      setCurrentPassage: (state, passage) => produce(state, draft => {
        draft.currentPassage = passage;
      }),

      setMainEndingReached: state => produce(state, draft => draft.hasReachedEnding = true)
    },
    effects: dispatch => ({
      beginStory(payload, rootState) {
        if (rootState[storyName].currentPassage == null)
          dispatch[storyName].advanceToPassage(firstPassage.name);
      },

      async restartStory(payload, rootState) {
        await dispatch[storyName].clearStoryData();
        await getPersistor().flush();
        location.reload();
      },

      advanceToPassage(nextPassageName, rootState) {
        const passageData = _.find(story.passages, { name: nextPassageName });
        if (!passageData) return;
        const nextPassage = new Passage(passageData);

        dispatch[storyName].setCurrentPassage(nextPassage);

        _.reduce(nextPassage.getReceivableMessages(), (accumulatedWait, message) => {
          accumulatedWait += message.getWaitUntilSent();

          message.timeOfArrival = new moment().add(accumulatedWait, "ms");
          dispatch[storyName].scheduleMessage(message);

          return accumulatedWait;
        }, 0);
        //TODO: mantener acumulador de wait para passages que se comunican inmediatamente

        dispatch[storyName].resumeScheduledMessages();
      },

      receivePendingMessagesInstantly(payload, rootState) {
        rootState[storyName].scheduledMessages.map(async scheduledMessage => {
          const message = new Message(scheduledMessage.message);
          clearTimeout(scheduledMessage.timerId);
          dispatch[storyName].receiveMessage(message);
          dispatch[storyName].clearScheduledMessage(message);
        })
      },

      sendMessage(message, rootState) {
        message.timeOfArrival = new moment();
        dispatch[storyName].receiveMessage(message);
        dispatch[storyName].advanceToPassage(message.nextPassageName);
      },

      async resumeScheduledMessages(payload, rootState) {
        await Promise.all(rootState[storyName].scheduledMessages.map(async scheduledMessage => {
          const message = new Message(scheduledMessage.message);

          const now = new moment();

          if (now.isBefore(message.timeOfArrival)) {
            const wait = new moment(message.timeOfArrival).diff(now, "ms");
            clearTimeout(scheduledMessage.timerId);
            await new Promise(resolve => {
              const timerId = setTimeout(resolve, wait);
              dispatch[storyName].updateScheduledMessage(message, timerId);
            });
          }

          dispatch[storyName].receiveMessage(message);
          dispatch[storyName].clearScheduledMessage(message);
        }));
      },
    })
  }
});